/**
 * Triggers a browser file download from a blob URL or object URL.
 * Replaces the 3+ copy-pasted anchor-click patterns in NodeDetailPanel.
 */
export default function triggerDownload(url, filename) {
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'download';
  document.body.appendChild(a);
  a.click();
  a.remove();
}
